module.exports = __webpack_public_path__ + "img/layout_horizontal_crisscross.76a77ffc.svg";